import { render, staticRenderFns } from "./BackofficeSensor.vue?vue&type=template&id=529c347e&"
import script from "./BackofficeSensor.vue?vue&type=script&lang=ts&"
export * from "./BackofficeSensor.vue?vue&type=script&lang=ts&"
import style0 from "./BackofficeSensor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports